import(/* webpackMode: "eager" */ "/var/www/vhosts/indianayurvedicproducts.com/httpdocs/src/app/crazy-deals/page.tsx");
